import { combineReducers } from 'redux'
import userInfomations from './userInfomations'

export default combineReducers({
  userInfomations,
})
